import Swiper from 'swiper/bundle';

export default {
    name : 'collection',

    init()
    {
        const items = document.querySelectorAll('.nomaCollection');
        if (items.length) {
            setTimeout(this.run, 100);
        }
    },
    run ()
    {
        const collections = document.querySelectorAll('.nomaCollection');

        if (!collections) {
            return false;
        }

        let sliderIds = [];
        collections.forEach( function(element){
            sliderIds.push(element.id)
        });

        let sliders = [];

        if (sliderIds.length) {
            for (let i=0; i<sliderIds.length;i++) {
                sliders[i] = new Swiper('#'+sliderIds[i] ,
                    {
                        navigation: {
                            nextEl: '#'+sliderIds[i]+ " ~ .swiper-button-next",
                            prevEl: '#'+sliderIds[i] + " ~ .swiper-button-prev",
                        },

                        scrollbar: {
                            el: '.swiper-scrollbar',
                            draggable: true,
                        },

                        centeredSlides: true,
                        slidesPerView: 'auto',
                        spaceBetween: 30,
                        breakpoints: {
                            768: {
                                freeMode: false,
                                slidesPerView: 3,
                            },

                            1200: {
                                centeredSlides: false,
                                slidesPerView: 4,
                                spaceBetween: 30,
                            }
                        },

                    }
                );
            }
        }


    } // run

} // export